
import React from 'react';

interface IconProps {
  size?: number;
}

const TailwindCssIcon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.438 7.438c.176 0 .34.055.48.15.295.193.43.538.332.868l-1.48 4.71c-.098.33-.393.555-.73.555h-3.418c-.337 0-.633-.225-.73-.555l-1.48-4.71c-.098-.33.037-.675.332-.868.14-.095.304-.15.48-.15h3.418zm-4.312 0c.176 0 .34.055.48.15.295.193.43.538.332.868l-1.48 4.71c-.098.33-.393.555-.73.555H7.72c-.337 0-.633-.225-.73-.555l-1.48-4.71c-.098-.33.037-.675.332-.868.14-.095.304-.15.48-.15h3.418z" fill="#38B2AC"/>
    </svg>
  );
};

export default TailwindCssIcon;
